import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CheckProgress } from "@app/shared/models/check-progress";
import { environment } from "@environments/environment";
import { shareReplay } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class QuestionService {
    private baseUrl = environment.apiUrl + "/api/v1";

    constructor(private http: HttpClient,) { }

    getQuestionProgess(questionUrl: string) {
        return this.http.get<CheckProgress[]>(`${this.baseUrl}/users/${questionUrl}/check-progress`)
            .pipe(
                shareReplay()
            );
    }

    getMangeProgess(questionUrl: string) {
        return this.http.get<CheckProgress[]>(`${this.baseUrl}/users/${questionUrl}/manage-progress`)
            .pipe(
                shareReplay()
            );
    }

    getPredictionInfo(type:string) {
        return this.http.get<CheckProgress[]>(`${this.baseUrl}/users/${type}/info`)
            .pipe(
                shareReplay()
            );
    }

    getStudyPlannInfo() {
        return this.http.get<CheckProgress[]>(`${this.baseUrl}/users/studyplan/info`)
            .pipe(
                shareReplay()
            );
    }

}